export default __webpack_public_path__ + "static/media/drag.e4c4cc31.svg";